<div class="position-relative" style="min-height: 630px; overflow: hidden">
    <div class="text-right p-3 position-absolute" style="width: 25%; top: 0; left: 75%; text-align: right; z-index: 10">
        <fa-icon [icon]="closeIcon" (click)="closeModal()" size="2x" class="clickable"></fa-icon>
    </div>
    <!-- Calendly inline widget begin -->
    <div class="calendly-inline-widget" data-url="https://calendly.com/gabrielle-robinson-1/introduction-to-swiss-school-of-management" style="min-width:320px;height:630px;overflow: hidden"></div>
    <!-- Calendly inline widget end -->
</div>
